import { ACTIVE_TAB, BANK_ACCOUNT } from "../../constants/ActionTypes";

const INIT_STATE = {
  activeTab: "1",
  bankAccounts: [],
};

const BankAccountReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACTIVE_TAB: {
      return {
        ...state,
        activeTab: action.payload,
      };
    }

    case BANK_ACCOUNT: {
      return {
        ...state,
        bankAccounts: action.payload,
      };
    }
    default:
      return state;
  }
};

export default BankAccountReducer;
